module.exports = __webpack_public_path__ + "static/media/after.ef4f1856.png";